export enum PurchaseLineVersionCategory {
    ONBOARDING = 'ONBOARDING',
    BULK_EDIT_UPLOAD = 'BULK_EDIT_UPLOAD',
    DETAIL_PAGE_EDIT = 'DETAIL_PAGE_EDIT',
    BULK_RECEIVING = 'BULK_RECEIVING',
    EXTERNAL_SYNC = 'EXTERNAL_SYNC',
}
